// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowSuggestion-cls1_rj_","cls2":"BulkFollowSuggestion-cls2_VUQ BulkFollowSuggestion-cls1_rj_"};